export default __webpack_public_path__ + "27945efc06def8bb176c19087a32e7b7.png";